import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography, { COLORS as LABEL_COLORS } from 'Components/UI/Typography';
import SwitchControl from './SwitchControl';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  switch: {},
  label: {},
});

const SwitchWithLabel = ({
  className,
  classes,
  label,
  labelColor,
  labelPosition,
  LabelProps,
  RootProps,
  ...rest
}) => {
  const labelComponent = (
    <Typography
      className={classes.label}
      color={labelColor}
      variant="h6"
      {...LabelProps}
    >
      {label}
    </Typography>
  );

  return (
    <div
      className={classNames(classes.root, className)}
      {...RootProps}
    >
      {(labelPosition === 'left') ? labelComponent : null}
      <SwitchControl
        className={classes.switch}
        {...rest}
      />
      {(labelPosition === 'right') ? labelComponent : null}
    </div>
  );
};

SwitchWithLabel.defaultProps = {
  className: '',
  labelColor: 'primaryGray',
  labelPosition: 'right',
};

SwitchWithLabel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  labelColor: PropTypes.oneOf(LABEL_COLORS),
  labelPosition: PropTypes.oneOf([
    'left',
    'right',
  ]),
};

export default withStyles(styles)(SwitchWithLabel);
